module.exports = __webpack_public_path__ + "static/PMB_get_started_wood-2b49a64f5241264f0f580a9846efe4de.png";